import { Column, Row } from "../../../../widget";
import { MapOpenLayerMultipleLayers } from "../../../../widget/general/Map/MapOpenLayer/MapOpenLayerMultipleLayers";
import { useLocation } from "./useLocation";

const Location = (): JSX.Element => {
  const { locationData, hoverOverlay, pointermoveFunc, centerCoordinate } = useLocation();

  // TODO: Getting this for the latitude and longitude coords, we should be basing this on all the different project coords instead see src\widget\general\Map\KanaMap\useKanaMap.ts for example
  return (
    <div className="TemplateTabCard">
      <Row spacingV="ml">
        <Column span={12}>
          <Row spacingV="xl">
            <Column span={12}>
              <h2>Location</h2>
            </Column>
          </Row>
          {locationData.length > 0 ? (
            <>
              <Row spacingV="m" justify="between">
                <Column span={12}>
                  <span>
                    Use the mapping tool to explore your landholding and project location. Note: only the base layer is
                    available in the 3D terrain view.
                  </span>
                </Column>
              </Row>
              <Row>
                <Column span={12}>
                  <div className="map-container">
                    <MapOpenLayerMultipleLayers
                      centerCoordinate={centerCoordinate}
                      gisFiles={locationData.map((e) => e.gisFile)}
                      drawLayer={undefined}
                      clearDrawBoundaryToggle={undefined}
                      hoverOverlay={hoverOverlay}
                      pointermoveFunc={pointermoveFunc}
                    />
                  </div>
                </Column>
              </Row>
            </>
          ) : (
            <Row spacingV="2xl" justify="between">
              <Column span={12}>
                <span>
                  No project location data found for this landholding, please upload any individual project location
                  data in the project dashboard.
                </span>
              </Column>
            </Row>
          )}
        </Column>
      </Row>
    </div>
  );
};

export default Location;
